<template>
    <form action="/settings/children" method="post" enctype="multipart/form-data" @submit="loading = true" :disabled="loading">
        <csrf></csrf>
        <div class="input-container">
            <div class="input-title">Install Suggestions For (Recommended)</div>
            <div class="input-checkbox">
                <div class="checkmark-container">
                    <label class="checkbox">
                        <input type="checkbox" id="example_behaviors" name="example_behaviors" value="1" checked>
                        <span class="checkmark"></span>
                    </label>
                </div>
                <label for="example_behaviors" class="input-checkbox-text">Behaviors</label>
            </div>
            <div class="input-checkbox">
                <div class="checkmark-container">
                    <label class="checkbox">
                        <input type="checkbox" id="example_outcomes" name="example_outcomes" checked>
                        <span class="checkmark"></span>
                    </label>
                </div>
                <label for="example_outcomes" class="input-checkbox-text">Outcomes (Costs &amp; Privileges)</label>
            </div>
            <div class="input-checkbox">
                <div class="checkmark-container">
                    <label class="checkbox">
                        <input type="checkbox" id="example_awards" name="example_awards" checked>
                        <span class="checkmark"></span>
                    </label>
                </div>
                <label for="example_awards" class="input-checkbox-text">Awards</label>
            </div>
        </div>
        <div class="input-container">
            <div class="input-title">First Name</div>
            <div class="input-box"><input type="text" name="first_name" v-model="form.first_name" required></div>
        </div>
        <div class="input-container">
            <div class="input-title">Last Name</div>
            <div class="input-box"><input type="text" name="last_name" v-model="form.last_name" required></div>
        </div>

        <photo-upload name="avatar" title="Profile Photo" preview-title="Photo To Upload"></photo-upload>

        <div class="input-container">
            <div class="input-title">Birthdate</div>
            <div class="input-box">
                <date-picker name="birthdate" format="F j, Y" placeholder="Select Birthdate" v-model="form.birthdate" required></date-picker>
            </div>
        </div>

        <div v-if="form.birthdate" class="input-container">
            <div class="input-checkbox">
                <div class="checkmark-container">
                    <label class="checkbox">
                        <input type="checkbox" id="confirm_age" name="confirm_age" value="1" v-model="form.confirm_age">
                        <span class="checkmark"></span>
                    </label>
                </div>
                <label for="confirm_age" class="input-checkbox-text">I confirm that {{ form.first_name || 'this child' }} is {{ selectedBirthAge }} year{{ selectedBirthAge !== 1 ? 's' : '' }} old.</label>
            </div>
        </div>

        <div class="input-container">
            <div class="input-title">After I Submit</div>
            <label class="input-radio">
                <input type="radio" name="redirect_action" value="/dashboard" :checked="!form.redirect_action || form.redirect_action === '/dashboard'">
                <span class="radio-checkmark"></span>
                <div class="radio-text">Take me to this child's dashboard</div>
            </label>
            <label v-if="canAddMore" class="input-radio">
                <input type="radio" name="redirect_action" value="/settings/children/create" :checked="form.redirect_action === '/settings/children/create'">
                <span class="radio-checkmark"></span>
                <div class="radio-text">Add another child</div>
            </label>
        </div>

        <button v-if="!loading" type="submit" class="submit-standard good-bg">Add Child<span class="fa fa-plus"></span></button>
        <button v-if="loading" type="submit" class="submit-standard neutral-bg" disabled>Processing...</button>
    </form>
</template>

<script>

import moment from 'moment';
import { mapState } from 'vuex';

export default {

    props: {
        old: {
            type: Object,
            default: {},
        },
        numChildren: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            form: (this.old && Object.values(this.old).length > 0) ? this.old : {}
        };
    },

    watch: {

    	'form.birthdate': function() {
    		this.$set(this.form, 'confirm_age', false);
        },

    },

    computed: {

        ...mapState({
            account: state => state.account,
        }),

        canAddMore() {
            return this.account.max_children_allowed > (this.numChildren + 1);
        },

		selectedBirthAge() {
        	if (!this.form.birthdate) return 'Unknown';

            const birthday = moment(this.form.birthdate);
            return moment().diff(birthday, 'years');
        },

    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/settings/children/AddChild.vue